document.addEventListener('DOMContentLoaded', (event) => {
  var countdownElement = document.querySelector('.countdown-timer');
  if (countdownElement) {
    var endDateString = countdownElement.dataset.endDate;
    var countDownDate = new Date(endDateString).getTime();

    var x = setInterval(function() {
      var now = new Date().getTime();
      var distance = countDownDate - now;
      
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      
      countdownElement.querySelector('.days').innerHTML = days + "d ";
      countdownElement.querySelector('.hours').innerHTML = hours + "h ";
      countdownElement.querySelector('.minutes').innerHTML = minutes + "m ";
      countdownElement.querySelector('.seconds').innerHTML = seconds + "s ";
      
      if (distance < 0) {
        clearInterval(x);
        countdownElement.innerHTML = "EXPIRED";
      }
    }, 1000);
  }
});
